import React, { Fragment, useEffect } from 'react';
import { Routes, Route, topbar } from "react-router-loading";
import { NavLink, useNavigate } from "react-router-dom";
import * as Remote from "./lib/RemoteClient";

import { isSetup } from './lib/api';
import SceneMain from './SceneMain';
import SceneSettings from './SceneSettings';

const JitsiMeetJS = window.JitsiMeetJS;
// const JitsiConfig = window.config;

// config topbar
topbar.config({
  autoRun: false,
  barThickness: 3,
  barColors: {
    0: 'rgba(255, 0, 0, .7)',
    .3: 'rgba(255, 0, 0, .7)',
    1.0: 'rgba(255, 0, 0, .7)'
  },
  shadowBlur: 5,
  shadowColor: 'red',
  className: 'topbar'
});

const AppLoadingScreen = () => (
  <>
    <div className="spinner-border" role="status">
      <span className="sr-only"></span>
    </div>
    Loading...
  </>
);


function Layout({ children }) {
  return (
    <>
      <Fragment>
        <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
          <div className="container-fluid">
            <NavLink to="/" activeclassname="active" className="nav-link">
              <h2 className='navbar-brand'>Video Betting | Application</h2>
            </NavLink>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample05" aria-controls="navbarsExample05" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="navbar-collapse collapse" id="navbarsExample05">
              <ul className="navbar-nav me-auto mb-2">
                <li className="nav-item">
                  <NavLink to="/" activeclassname="active" className="nav-link">
                    <i className="bi bi-broadcast"></i> <span>Broadcast</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/settings" activeclassname="active" className="nav-link">
                    <i className="bi bi-gear-fill"></i> <span>Settings</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <article>
          {children}
        </article>
        <div className="col-lg-8 mx-auto p-3 py-md-1">
          <footer className="pt-5 my-5 text-muted border-top">
            Created by the SUGA © 2022
          </footer>
        </div>
      </Fragment>
    </>
  )
}



function App() {
  let navigate = useNavigate();

  useEffect(() => {
    JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
    JitsiMeetJS.init({
      disableAudioLevels: true
    });

    if (!isSetup()) {
      return navigate("/settings");
    }

  }, []);

  return (
    <Layout>
      <Routes
        loadingScreen={AppLoadingScreen}
        maxLoadingTime={10}
      >
        <Route path="/" element={<SceneMain />} loading />
        <Route path="/settings" element={<SceneSettings />} loading />
      </Routes>
    </Layout>
  );
}

export default App;